/** Icônes officielles Google et Microsoft pour les calendriers connectés. */

import { cn } from '@/lib/utils'
import type { CalendarProvider } from '@/api/calendars'

export function GoogleIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className}>
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  )
}

export function MicrosoftIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 21 21" className={className}>
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  )
}

export function SquareIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className}>
      <rect x="2" y="2" width="20" height="20" rx="4" fill="#000000" />
      <rect x="8" y="8" width="8" height="8" rx="1.5" fill="#ffffff" />
    </svg>
  )
}

/** The word "Wix", drawn with strokes so it renders the same everywhere. Follows the text color. */
export function WixIcon({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 45 24"
      className={cn('text-slate-900 dark:text-white', className)}
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 6l5 13 4.5-11 4.5 11 5-13" />
      <path d="M27 11v8" />
      <circle cx="27" cy="5.5" r="1.9" fill="currentColor" stroke="none" />
      <path d="M32.5 11l8 8M40.5 11l-8 8" />
    </svg>
  )
}

export function ProviderBadge({
  provider,
}: {
  provider: CalendarProvider
}) {
  if (provider === 'google') return <GoogleIcon className="w-4 h-4 shrink-0" />
  if (provider === 'square') return <SquareIcon className="w-4 h-4 shrink-0" />
  if (provider === 'wix') return <WixIcon className="w-4 h-4 shrink-0" />
  return <MicrosoftIcon className="w-4 h-4 shrink-0" />
}
